import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { clearAuthStorage } from "@/utils";
import apiClient from "@/services/apiClient";

const useLoadData = (url) => {
  const [requestedData, setRequestedData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!url) return;

    setIsLoaded(false);
    setError(null);
    setRequestedData([]);

    const fetchData = async () => {
      try {
        const response = await apiClient.get(url);
        const response_json = response.data;
        const data = response_json ? response_json["data"] : [];
        setRequestedData(data);
        setIsLoaded(true);
      } catch (err) {
        if (err.response?.status === 401) {
          console.warn("Unauthorized access - redirecting to login");
          clearAuthStorage();
          localStorage.setItem(
            "redirectAfterLogin",
            location.pathname + location.search,
          );
          navigate("/login");
          return;
        }
        console.error("Error fetching data:", err);
        const errorMessage =
          err.response?.data?.message ||
          err.message ||
          `HTTP error! Status: ${err.response?.status}`;
        setError(new Error(errorMessage));
      }
    };

    fetchData();
  }, [url, navigate, location]);

  return [requestedData, isLoaded, error];
};

export default useLoadData;
